import { DetailsCard, SuccessBanner, Tabs, Table, InfoBanner, WarningBanner } from './components';
import { extendTheme } from '../../../theme';
import defaultTheme from '../../../theme/default-theme';
var theme = extendTheme(defaultTheme, {
  name: 'PP2 England',
  colors: defaultTheme.colors,
  components: {
    DetailsCard,
    Tabs,
    Table,
    SuccessBanner,
    WarningBanner,
    InfoBanner
  }
});
export default theme;